<template>
  <div class="sign">
    <el-form
      :model="dataObj"
      ref="dataObjForm"
      label-width="0px"
      class="demo-ruleForm"
      :rules="rules"
    >
      <div class="sign-title">用户注册</div>
      <div class="sign-name">手机号</div>
      <div class="sign-input">
        <el-form-item prop="mobile">
          <el-input
            v-model="dataObj.mobile"
            placeholder="请输入手机号码"
          ></el-input>
        </el-form-item>
      </div>
      <div class="sign-name">验证码</div>
      <div class="sign-input sign-input-code">
        <el-form-item prop="code">
          <el-input
            v-model="dataObj.code"
            placeholder="请输入验证码"
          ></el-input>
        </el-form-item>
        <span @click="setTimeCode">{{ codeName }}</span>
      </div>
    </el-form>
    <div
      class="button"
      :class="{ buttonAct: dataObj.mobile && dataObj.code }"
      @click="buttonRegister"
    >
      登录
    </div>
  </div>
</template>

<script>
import { sendCode, register } from "@/api/api.js";

export default {
  data() {
    const checkAge = (rule, value, callback) => {
      let myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
      if (value === "") {
        callback(new Error("手机号不能为空"));
      } else if (!myreg.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    return {
      dataObj: {
        mobile: "",
        code: "",
        openId: ""
      },
      rules: {
        code: [{ required: true, message: "验证码不能为空" }],
        mobile: [{ validator: checkAge, trigger: "blur" }]
      },
      codeName: "获取验证码",
      timeCode: "",
      timeNum: 0
    };
  },
  methods: {
    setTimeCode() {
      let myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
      if (this.dataObj.mobile === "" || !myreg.test(this.dataObj.mobile))
        return;
      if (this.timeNum === 0) {
        const that = this;
        this.timeNum = 20;
        this.sendCode();
        this.timeCode = setInterval(() => {
          that.timeNum--;
          if (that.timeNum === 0) {
            that.codeName = `重新获取`;
            clearInterval(that.timeCode);
          } else {
            that.codeName = `${that.timeNum}秒`;
          }
        }, 1000);
      }
    },
    // 获取验证码
    sendCode() {
      sendCode(this.dataObj.mobile).then(res => {
        if (res.code !== 0) {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    },
    // 注册
    buttonRegister() {
      this.$refs.dataObjForm.validate(valid => {
        if (valid) {
          const ListObj = JSON.parse(window.sessionStorage.getItem("userList"));
          this.dataObj.openId = ListObj.openId;
          this.register();
        } else {
          return false;
        }
      });
    },
    register() {
      register(this.dataObj).then(res => {
        if (res.code === 0) {
          const obj = {
            expirationDate: res.data.expirationDate,
            head: res.data.head,
            id: res.data.id,
            isExpire: res.data.isExpire,
            mobile: res.data.mobile,
            name: res.data.name
          };
          window.sessionStorage.setItem("userList", JSON.stringify(obj));
          this.$router.push({ name: "H5my" });
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    }
  }
};
</script>

<style lang="less">
.sign {
  width: 100%;
  padding: 16px;
  box-sizing: border-box;
  &-title {
    margin: 20px 0 40px;
    font-size: 18px;
    color: #141414;
    font-weight: bold;
  }
  &-name {
    margin-bottom: 10px;
    font-size: 14px;
    color: #141414;
  }
  &-input {
    margin-bottom: 20px;
    border-bottom: 1px solid #e7e7e7;
    .el-form-item {
      margin: 0;
      .el-input__inner {
        border: none;
      }
    }
  }
  &-input-code {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .el-form-item {
      width: calc(100% - 100px);
    }
    span {
      display: block;
      text-align: center;
      height: 40px;
      width: 80px;
      line-height: 40px;
      font-size: 13px;
      color: #3a6ee9;
    }
  }
  .button {
    margin: 30px auto 0;
    width: 320px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    background: #cccccc;
    border-radius: 4px;
    font-size: 18px;
    color: #ffffff;
    text-align: center;
  }
  .buttonAct {
    background: #3a6ee9;
  }
}
</style>
